import React from 'react';
import {element, node, string, oneOfType} from 'prop-types';
import classNames from 'classnames';
import styles from './overlayView.scss';

function OverlayView(props) {
    const { children, className } = props;
    const overlayClasses = classNames(styles.body, className);
    return (
        <div className={overlayClasses}>
            {children}
        </div>
    );
}

OverlayView.propTypes = {
    children: oneOfType([element, node]),
    className: string
};

export default OverlayView;



// WEBPACK FOOTER //
// ./src/components/MobileNav/OverlayView/OverlayView.jsx